import React from "react";
import { Paper, Box, Typography, Button } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";

const EmptyState = ({
  title,
  description,
  searchQuery,
  onClearSearch,
  flatIdFromUrl,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        py: 8,
        borderRadius: 2,
        bgcolor: "white",
        border: "1px solid #e5e7eb",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: 500,
          mx: "auto",
          px: 3,
        }}
      >
        <AssignmentIcon sx={{ fontSize: 80, color: "#cbd5e1", mb: 2 }} />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#1e293b",
            mt: 3,
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3, lineHeight: 1.6 }}
        >
          {description}
        </Typography>
        {searchQuery ? (
          <Button
            variant="contained"
            onClick={onClearSearch}
            sx={{
              bgcolor: "#667eea",
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                bgcolor: "#5568d3",
              },
            }}
          >
            Clear Search
          </Button>
        ) : (
          !flatIdFromUrl && (
            <Button
              variant="contained"
              onClick={() => (window.location.href = "/find-property")}
              sx={{
                bgcolor: "#667eea",
                px: 3,
                py: 1,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  bgcolor: "#5568d3",
                },
              }}
            >
              Find Property
            </Button>
          )
        )}
      </Box>
    </Paper>
  );
};

export default EmptyState;